const bgImage = 'https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty/images/03-sanctuary-club_49.jpg';

const gifImage = [
  { image: 'https://lagunaproperty.com/images/exchange-1.gif', text: 'An owner deposits 15 annual entitlement days into the exchange pool' },
  { image: 'https://lagunaproperty.com/images/exchange-2.gif', text: 'The days are attributed a monetary value' },
  {
    image: 'https://lagunaproperty.com/images/exchange-3.gif',
    text: 'The monetary value can then be used to redeem stays at participating properties at the best available rate at time of booking'
  },
  { image: 'https://lagunaproperty.com/images/exchange-4.gif', text: 'Booking can be requested via the centralised multilingual team' },
  {
    image: 'https://lagunaproperty.com/images/exchange-5.gif',
    text: 'A confirmation of your reservation will be sent to you along with value redeemed and your remaining balance'
  },
  { image: 'https://lagunaproperty.com/images/exchange-6.gif', text: 'Enjoy your stays at participating properties' }
];

export {
  gifImage,
  bgImage
};



// WEBPACK FOOTER //
// ./src/data/SanctuaryClub/exchange.js